import { Component, OnInit } from '@angular/core';
import { CandidateDataLoadState, OverviewClient, ResultSummaryDto, ResultType } from '@shared/clients/api.generated';
import { MapAreasMapping } from '@shared/components/map/map-styles.model';
import { SidenavigationLink } from '@shared/components/sidenavigation/sidenavigation.model';
import { SvgIcon } from '@valg-shared/utils/svg-icon';
import { ExtendedElectionDto, LatestUpdatesDistrictColumnDef, LatestUpdatesDistrictDto } from '../election-overview.model';
import { ActivatedRoute, Router } from "@angular/router";
import { ElectionOverviewService } from "../election-overview.service";
import { SidenavigationLinkType } from '@shared/components/page-layout/page-layout.model';
import { ReferendumStatus } from "@shared/components/cards/referendum-status/referendum-status.model";
import { MapAreaClickedEvent } from "@shared/components/map/map-events.model";

@Component({
  selector: 'valg-dk-fa-election-overview',
  templateUrl: './fa-election-overview.component.html'
})
export class FaElectionOverviewComponent implements OnInit {

  election?: ExtendedElectionDto;

  readonly SvgIcon = SvgIcon;
  public mapAreasMapping?: MapAreasMapping;
  links: SidenavigationLink[] = []

  sideNavTitleType = SidenavigationLinkType.NominationDistrict;
  countStatus: { name: string, percentage: number }[] = [];
  countStatusUpdated: Date | undefined;

  candidateDataLoadState: CandidateDataLoadState = CandidateDataLoadState.NotLoaded;

  latestUpdatesDistrictColumnDef = LatestUpdatesDistrictColumnDef;
  latestUpdates: LatestUpdatesDistrictDto[] = [];


  referendumStatus: ReferendumStatus[] = [];
  resultType: ResultType = ResultType.NoResults;
  resultSummary!: ResultSummaryDto;

  constructor(
    private readonly electionOverviewService: ElectionOverviewService,
    private readonly overviewClient: OverviewClient,
    private readonly router: Router,
    private readonly route: ActivatedRoute
    ) {}

  async ngOnInit(): Promise<void> {
    await this.initializeCurrentElection();
    this.initializeConstituency();
    this.initializeElectionOverview();
  }

  private async initializeCurrentElection() {
    this.election = await this.electionOverviewService.getCurrentElection();
  }

  private initializeConstituency() {
    this.overviewClient.getElectionSideNavigation().subscribe((result) => {
      this.links = this.electionOverviewService.mapConstituencies(result);
    })
  }

  private initializeElectionOverview() {
    this.electionOverviewService.getElectionOverviewData(this.overviewClient.getFaElectionOverview())
      .subscribe(({ countStatus, resultType, countStatusUpdated, latestUpdates,
                    referendumStatus, mapAreaMapping, candidateDataLoadState, resultSummary }) => {
        this.countStatus = countStatus;
        this.resultType = resultType;
        this.countStatusUpdated = countStatusUpdated;
        this.latestUpdates = latestUpdates;
        this.referendumStatus = referendumStatus;
        this.mapAreasMapping = mapAreaMapping;
        this.candidateDataLoadState = candidateDataLoadState;
        this.resultSummary = resultSummary;
      });
  }

  async onAreaClick($event: MapAreaClickedEvent) {
    const id = $event.data?.id;
    if (id) {
      const link = this.electionOverviewService.getNominationDistrictLink(id);
      await this.router.navigate([ link ], {
          relativeTo: this.route,
        }
      );
    }
  }

}
